import React, { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { isQrHost } from 'constants/qr';
import { useAppSelector } from 'store/hooks';

import AuthRoutes from './auth';
import CmsRoutes from './cms';
import PortalRoutes from './portal';
import QrRoutes from './qr';

const RootRoutes = (): JSX.Element => {
  const location = useLocation();

  const isCms = useMemo(() => location.pathname.includes('/cms/'), [
    location.pathname,
  ]);

  // Public QR interstitial: dedicated host (qr.rworldreuse.com/:code) or
  // same-origin test path (/qr/:code).
  const isQr = useMemo(
    () => isQrHost() || location.pathname.startsWith('/qr/'),
    [location.pathname],
  );

  const isLoggedIn = useAppSelector(
    (state) => state?.auth?.currentUser?.tokens?.jwtToken,
  );

  /* Revert when the auth API is available */
  const Routes = useMemo(() => {
    if (isQr) {
      return QrRoutes;
    }

    if (isCms) {
      return CmsRoutes;
    }

    if (isLoggedIn) {
      return PortalRoutes;
    }

    return AuthRoutes;
  }, [isQr, isCms, isLoggedIn]);

  return <Routes />;
};

export default RootRoutes;
